import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="A" transform="translate(11.000000, 5.000000)">
        <path
          d="M 50 61 L 45 61 L 42.5 52.5 L 35.5 52.5 L 33 61 L 28 61 L 36 30.3 L 42 30.3 L 50 61 Z M 39 34.6 L 36.5 47.5 L 41.5 47.5 L 39 34.6 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
